export class EdaKnob{
  data:any;
  dataDescription : any;
  limits:Array<number>;
  assignedColors: any;
}